import { FC } from 'react'
import { Row } from '@/root/shared-types'
import { TableCell } from '../TableCell/TableCell'

interface TableBodyProps {
  rows: Row[]
}

export const TableBody: FC<TableBodyProps> = ({ rows }) => (
  <div className="w-full">
    {rows.map(({ type, price }) => (
      <div className="border-neutral-very-light grid w-full grid-cols-2 border border-t-0" key={`${type}-${price}`}>
        <TableCell label={type} />
        <TableCell label={price} />
      </div>
    ))}
  </div>
)
